import { constants } from '@wsb/guac-widget-core';
import { FILL, FIT, INSET, WIDE_INSET, FLEX_FILL } from '../../common/constants/headerTreatments';
import { COMMON_BUTTON_CONFIG } from '../../common/constants';
import imageToHeaderTreatments from '../../common/utils/imageToHeaderTreatments';
import { IMAGE, VIDEO, NONE } from '../../common/constants/mediaTypes';
import { TREATMENTS } from './treatments';

const {
  colorPackCategories: { NEUTRAL },
  buttons,
  contentPositions: { CENTER }
} = constants;
const { LIGHT, LIGHT_ALT, LIGHT_COLORFUL, DARK, DARK_ALT, DARK_COLORFUL, COLORFUL } =
  constants.paintJobs;

const id = 'layout27';
const imageTreatments = {
  [FILL]: 'none',
  [FIT]: 'none',
  [INSET]: 'category-solid',
  [WIDE_INSET]: 'category-solid',
  [FLEX_FILL]: 'none'
};
const defaultHeaderTreatment = INSET;
const headerTreatments = imageToHeaderTreatments(imageTreatments);
const headerTreatmentsConfig = {
  defaultHeaderTreatment,
  hasLegacy: false,
  imageTreatments,
  headerTreatments,
  defaultProps: {
    [FLEX_FILL]: {
      fullWidthMedia: false,
      hasNavWithBackground: false,
      roundedCorners: true,
      category: NEUTRAL,
      contentPosition: CENTER,
      alignment: 'center'
    }
  },
  mediaSupport: {
    [NONE]: [defaultHeaderTreatment],
    [IMAGE]: Object.keys(imageTreatments),
    [VIDEO]: [defaultHeaderTreatment, FLEX_FILL]
  }
};
const defaultPaintJob = LIGHT;

export default {
  id,
  name: 'bisque',
  packs: {
    color: '#CB4154',
    font: 'playfair-display'
  },
  logo: {
    font: 'primary'
  },
  packCategories: {
    color: NEUTRAL
  },
  headerProperties: {
    alignmentOption: 'center',
    defaultLogoAlign: 'center'
  },
  headerTreatmentsConfig,
  paintJobs: [LIGHT, LIGHT_ALT, LIGHT_COLORFUL, COLORFUL, DARK_COLORFUL, DARK_ALT, DARK],
  defaultPaintJob,
  applyDefaultPaintJob: true,
  buttons: {
    treatments: [
      TREATMENTS.SOLID,
      TREATMENTS.OUTLINE,
      TREATMENTS.LINK,
      TREATMENTS.GLASS,
      TREATMENTS.DIAGONAL_STRIPED,
      TREATMENTS.TEXT_ICON,
      TREATMENTS.WAVY
    ],
    primary: {
      fill: buttons.fills.SOLID,
      shape: buttons.shapes.SQUARE,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.PRIMARY
    },
    secondary: {
      fill: buttons.fills.SOLID,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.PRIMARY
    },
    ...COMMON_BUTTON_CONFIG
  },
  defaultNavFamily: 'navFamily3'
};
